import { useState, useMemo } from "react";
import * as Icon from "react-feather";

import Button from "../common/Button";
import Card from "../common/Card";
import Form from "../common/Form";

import logo from "./../../assets/images/empower-logo-box.png";
import APIManager from "../../managers/APIManager";
import { useLocation, useNavigate } from "react-router";

const initialState = {
  errorMessage: null,
  errors: {
    name: null,
    password: null,
    password2: null,
  },
  loading: false,
  values: {
    name: "",
    password: "",
    password2: "",
  },
  isActivationSuccess: false,
};

const AuthActivate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const code = useMemo(() => searchParams.get("code"), [searchParams]);
  const reset = useMemo(() => searchParams.get("reset"), [searchParams]);

  const [errorMessage, setErrorMessage] = useState(initialState.errorMessage);
  const [errors, setErrors] = useState(initialState.errors);
  const [loading, setLoading] = useState(initialState.loading);
  const [isActivationSuccess, setIsActivationSuccess] = useState(
    initialState.isActivationSuccess
  );

  const [password, setPassword] = useState(initialState.values.password);
  const [password2, setPassword2] = useState(initialState.values.password2);
  const [name, setName] = useState(initialState.values.name);

  const onBlur = (e) => {
    e && e.preventDefault();
    const errorsVar = errors;
    if (!e.target.value.length) {
      errorsVar[e.target.name] = "This is a required field!";
    } else {
      errorsVar[e.target.name] = null;
    }
    setErrors(errorsVar);
  };

  const onChange = (e) => {
    e && e.preventDefault();
    if (e.target.name === "password") setPassword(e.target.value);
    if (e.target.name === "password2") setPassword2(e.target.value);
    if (e.target.name === "name") setName(e.target.value);
  };

  const onSubmit = (e) => {
    e && e.preventDefault();
    setErrors(initialState.errors);
    setErrorMessage(initialState.errorMessage);
    setLoading(true);
    if (password !== password2) {
      const errorsVar = errors;
      errorsVar.password2 = "Passwords must match!";
      setErrors(errorsVar);
      setErrorMessage("Passwords must match!");
      setIsActivationSuccess(false);
      setLoading(false);
      return;
    }

    APIManager.activate({
      code: code.trim(),
      name: name.trim(),
      password: password.trim(),
    })
      .then(() => {
        setErrorMessage("");
        setIsActivationSuccess(true);
        setTimeout(() => {
          const redirectUrl = searchParams.get("referrer") || "/";
          navigate(redirectUrl);
        }, 1000);
      })
      .catch(() => {
        setErrorMessage(
          "Your activation code seems to be invalid, please contact us and try again."
        );
      });
  };
  return (
    <div className="max-w-sm m-auto h-screen flex flex-col">
      <div className="my-auto">
        <img
          src={logo}
          width="150"
          className="mb-3 m-auto"
          alt="Empower Logo"
        />
        {errorMessage ? (
          <div
            className="bg-red-100 border-l-4 border-red-500 rounded-b text-red-900 px-4 py-3 shadow mb-3"
            role="alert"
          >
            <div className="flex">
              <div className="py-1">
                <Icon.Info className="h-6 w-6 text-red-500 mr-4" />
              </div>
              <div>
                <p className="font-bold">Activation Failed</p>
                <p className="text-sm">{errorMessage}</p>
              </div>
            </div>
          </div>
        ) : isActivationSuccess ? (
          <div
            className="bg-green-100 border-l-4 border-green-500 rounded-b text-green-900 px-4 py-3 shadow mb-3"
            role="alert"
          >
            <div className="flex">
              <div className="py-1">
                <Icon.Info className="h-6 w-6 text-green-500 mr-4" />
              </div>
              <div>
                <p className="font-bold">Activation Successful</p>
                <p className="text-sm">You will be redirected to login page.</p>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <Card
          className="p-3"
          title={
            reset === "1" ? "Reset your password" : "Activate Your Account"
          }
        >
          <Card.Body>
            <Form>
              {reset !== "1" && (
                <Form.FormTextInput
                  name="name"
                  label="Full Name"
                  placeholder="Full name"
                  onChange={onChange}
                  onBlur={onBlur}
                  value={name}
                  error={errors && errors.name}
                />
              )}
              <Form.FormTextInput
                name="password"
                type="password"
                label="New Password"
                required={true}
                placeholder="Password"
                onChange={onChange}
                onBlur={onBlur}
                value={password}
                error={errors && errors.password}
              />
              <Form.FormTextInput
                name="password2"
                type="password"
                label="New Password (again)"
                required={true}
                placeholder="Password"
                onChange={onChange}
                onBlur={onBlur}
                value={password2}
                error={errors && errors.password2}
              />
              <Button
                className="w-full"
                color="primary"
                onClick={onSubmit}
                loading={loading}
                disabled={loading}
                type="submit"
              >
                {reset === "1" ? "Reset password" : "Set Password"}
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default AuthActivate;
